(function ($) {
    $(".accordion__section button").click(function () {
        var current = $(this).parent();
        if ($(current).hasClass("accordion__section--open")) {
            $(current).removeClass("accordion__section--open");
            $(current).children(".accordion__section__content").slideUp();
        } else {
            $(current).siblings().removeClass("accordion__section--open");
            $(current).siblings().children(".accordion__section__content").slideUp();

            $(current).addClass("accordion__section--open");
            $(current).children(".accordion__section__content").slideDown();
        }
    });

})(jQuery);